module.exports = __webpack_public_path__ + "img/right_bg.164e7494.png";